import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { ChangeEvent } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  setOTPPopupOpen,
  verifyOTP,
  setOTP,
} from "src/redux/slices/bMCProfileSlice";
import { OTPType } from "src/resources/enum";
import { isNullOrWhiteSpace } from "src/utils/helpers";
import "./Otp.scss";
import { OTP_LENGTH } from "src/resources/constant";

type OTPProps = {
  callbackFn: (isValid: boolean) => void;
  otpType: OTPType;
  onOtpPopupClose?: () => void;
  IdentifierKey?: string;
  handleRegenerateOTP?: (e: any) => void;
};
// use react.memo to prevent unnecessary re-renders

const OTP = React.memo(
  ({ callbackFn, otpType, onOtpPopupClose, IdentifierKey,handleRegenerateOTP }: OTPProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isOTPPopupOpen, otp, BMCData } = useSelector(
      (state: any) => state.bMCProfile
    );
    const { t } = useTranslation(["common", "user"]);

    const handleSubmitOTP = async (e: any) => {
      e.preventDefault();
      if (!IdentifierKey) {
        if (otpType === OTPType.Email) {
          IdentifierKey = BMCData.email;
        } else {
          IdentifierKey = BMCData.phoneNumber;
        }
      }
      const hideOTP = (hideOTP: boolean) => {
        if (hideOTP) {
          onClose();
        }
      };
      if (IdentifierKey) {
        const isValid = await dispatch(
          verifyOTP(IdentifierKey, hideOTP) as any
        );
        callbackFn(isValid);
      }
    };

    function handleOTP(e: ChangeEvent<HTMLInputElement>): void {
      dispatch(setOTP(e.target.value));
    }
    const closeOTPPopup = () => {
      dispatch(setOTPPopupOpen(false) as any);
    };

    function handleResendOTP(e: any): void {
      e.preventDefault();
    }

    const onClose = () => {
      onOtpPopupClose?.();
      closeOTPPopup();
    };
    return (
      <Dialog
        visible={isOTPPopupOpen}
        onHide={onClose}
        closable
        className="otp-popup"
      >
        <div className="card-header d-flex mb-1 justify-content-center">
          <Trans>
            <p className="otp-message m-0">
              {t(otpType === OTPType.Email ? "otpEmailTitle" : "otpSMSTitle")}
            </p>
          </Trans>
        </div>
        <form
          className="d-flex flex-column justify-content-center"
          onSubmit={handleSubmitOTP}
        >
          <div className="form-control mb-2">
            <label className="mb-2" htmlFor="otp">
              {t("otpLabel")}
            </label>
            <InputText
              id="otp"
              name="otp"
              placeholder={t("otpPlaceholder")}
              className="w-100"
              autoComplete="false"
              onChange={handleOTP}
            />
          </div>

          <Button
            label={t("verify")}
            className="primary-btn border-radius-100"
            disabled={otp.length !== OTP_LENGTH || isNullOrWhiteSpace(otp)}
          />
          <div className="d-flex justify-content-center align-items-center gap-1">
            <span> {t("didntReceiveOTP")}</span>
            <Button
              className="light-primary-btn primary-text-btn"
              label={t("clickHere")}
              onClick={handleRegenerateOTP}
            />
          </div>
        </form>
      </Dialog>
    );
  }
);

export default OTP;
